import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Package } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';

export default function Wishlist({ onOpen }) {
  const { items, remove } = useWishlist();

  if (!items.length) return (
    <div className="bg-white rounded-xl border p-10 text-center">
      <Heart className="w-10 h-10 mx-auto text-neutral-400" />
      <h3 className="mt-3 font-serif text-xl">Your wishlist is empty</h3>
      <p className="text-sm text-neutral-600 mt-1">Tap the heart on any product to save it here for later.</p>
      <Link to="/collection/all" className="inline-block mt-4 bg-[#1e3a2b] hover:bg-[#2a5040] text-white px-6 py-2.5 rounded-md font-semibold">Browse products</Link>
    </div>
  );

  return (
    <div className="space-y-4">
      <h2 className="font-serif text-2xl text-neutral-900">My Wishlist ({items.length})</h2>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <div key={p.id} className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
            <Link to={`/product/${p.id}`} className="block">
              <div className="aspect-square bg-neutral-100 overflow-hidden">
                <img src={p.image} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
              </div>
            </Link>
            <div className="p-3">
              <Link to={`/product/${p.id}`} className="font-serif text-base text-neutral-900 line-clamp-1 hover:text-[#b8935a]">{p.title.split('|')[0]}</Link>
              <div className="mt-1 text-sm">
                <span className="font-bold">Rs. {p.price.toLocaleString('en-IN')}</span>{' '}
                <span className="text-neutral-500 line-through text-xs">Rs. {p.originalPrice.toLocaleString('en-IN')}</span>
              </div>
              <div className="mt-3 flex gap-2">
                {onOpen && <button onClick={() => onOpen(p)} className="flex-1 bg-[#1e3a2b] hover:bg-[#2a5040] text-white text-sm font-semibold py-2 rounded-md transition-colors">Add to cart</button>}
                <button onClick={() => remove(p.id)} className="px-3 py-2 border border-neutral-300 rounded-md text-sm text-neutral-700 hover:bg-neutral-100 transition-colors">Remove</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
